import React, { useLayoutEffect, useEffect, useRef, useState  } from "react"
import Layout from "../components/layout"
import Video from "../components/video"
import TransitionLink from 'gatsby-plugin-transition-link'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { StaticImage } from "gatsby-plugin-image"
import VisibilitySensor from 'react-visibility-sensor'
import ReactPlayer from 'react-player'
import useWindowSize from "../hooks/useWindowDimensions"
import Footer from "../components/footer"
import chevronDown from "../images/angle-down.svg"
//import VideoSrc from "../videos/Sprint2_RiskManagement_RiskAssessmentProcess.mp4"
import VideoSrc from "../videos/Sprint2_RiskManagement_RiskAssessmentProcess_060722.mp4"
// import VideoSrcMobile from "../images/16-9.jpg"
import prevImage from "../images/Hero_07_Planning.jpg"
import nextImage from "../images/Hero_08_Innovation.jpg"
import prevRings from "../images/RINGS_BLUE_YELLOW.svg"
import nextRings from "../images/RINGS_CYAN_YELLOW.svg"
import arrowLeft from "../images/yellow-arrow.svg"
import { Link } from "gatsby"
import "../components/pages.scss"
import ringsgy from "../images/RINGS_GREEEN_YELLOW.svg"
import ringsmy from "../images/RINGS_MAGENTA_YELLOW.svg"
import ringscy from "../images/RINGS_CYAN_YELLOW.svg"
import ringsbm from "../images/RINGS_BLUE_MAGENTA.svg"
import ringsby from "../images/RINGS_BLUE_YELLOW.svg"

gsap.registerPlugin(ScrollTrigger);

const RiskManagementPage = (props) => {
    const size = useWindowSize();
    const firstRow = useRef();
    const circles = useRef([]);
    const navList = useRef();
    const [desktopViewState, setDesktopViewState] = useState(null);

    useLayoutEffect(() => {
        console.log(circles);
        for(let x = 0; x < circles.current.length; x++) {
            gsap.to(circles.current[x], {
                x: (i, target) => -1000 * target.dataset.speed,
                ease: "none",
                scrollTrigger: {
                    trigger: circles.current[x],
                    scrub: true,
                }
            });
        }

        gsap.from(navList.current, {
            y: "-100%",
            duration: .35,
            ease: "power2"
        });
    }, []);

    function exitAnimation(exit, node, int) {
        gsap.to(navList.current, {
            y: "-100%",
            duration: .35,
            ease: "power2"
        });
    }

    const [playVideo, setPlayVideo] = useState(false);
	function onChangeVideo(isVisible) {
		if(isVisible) {
			setPlayVideo(true);
		}
	}

    const [videoUrl, setVideoUrl] = useState(VideoSrc);
	useEffect(() => {
		const mql = window.matchMedia('(min-width: 64rem)');
		setDesktopViewState(mql.matches);

		if(desktopViewState) {
			setVideoUrl(VideoSrc);
		} else {
			setVideoUrl(VideoSrc);
		}
	}, [size, desktopViewState]);

    return (
        <Layout>
            <main className="page risk-management">
                <title>Risk Management</title>
                <div className="row nav">
                    <div className="col-xs-12">
                        <nav>
                            <ul ref={navList}>
                                <li>
                                    <Link
                                        className="back-button"
                                        activeClassName="active"
                                        to="/"
                                        state={{ pageId: 7 }}
                                    >
                                        <img src={arrowLeft} alt=""/>
                                    </Link>
                                </li>
                                <li className="blue-bar">|</li>
                                <li data-url="risk-management">Risk Management</li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div className="page-set">
                    <div className="wrapper">
                        <div className="container">
                            <section className="panel">
                                <div className="wrap">
                                    <div className="profile">
                                        <StaticImage loading="eager" objectFit="contain" placeholder="blurred" quality="50" className="avatar" src="../images/Hero_06_RiskManagement.jpg" alt="" />
                                        <img className="rings" src={ringsby} alt="" /> 
                                    </div>
                                    <div className="info">
                                        <div className="title--super text--outline">EVOLVING</div>
                                        <h1>PROGRESS</h1>
                                        <div className="button-wrap">
                                            <TransitionLink
                                                className="button"
                                                to="/"
                                                exit={{
                                                    
                                                }}
                                                entry={{
                                                }}
                                            >
                                                Read Welcome
                                            </TransitionLink>
                                        </div>
                                    </div>
                                    <img className="chevron-down" src={chevronDown} alt="" /> 
                                </div>
                                <div 
                                    className="circle--pink top"
                                    ref={(element) => circles.current[0] = element}
                                    data-speed=".3"
                                ></div>
                                <div
                                    className="circle--blue top" 
                                    ref={(element) => circles.current[1] = element}
                                    data-speed="-.1"
                                ></div>
                                <div
                                    className="circle--yellow top" 
                                    ref={(element) => circles.current[3] = element}
                                    data-speed=".5"
                                ></div>
                            </section>
                        </div>
                    </div>
                </div>
                <div className="row row-wrapper first-row content" ref={firstRow}>
                   <div className="col-xs-12">
                       <div className="video-wrap">
                           <Video
                                videoSrcURL="https://cdnapisec.kaltura.com/p/2223971/sp/222397100/embedIframeJs/uiconf_id/37498831/partner_id/2223971?iframeembed=true&playerId=kaltura_player&entry_id=1_2fya9lcf&flashvars[streamerType]=auto&amp;flashvars[localizationCode]=en&amp;flashvars[leadWithHTML5]=true&amp;flashvars[sideBarContainer.plugin]=true&amp;flashvars[sideBarContainer.position]=left&amp;flashvars[sideBarContainer.clickToClose]=true&amp;flashvars[chapters.plugin]=true&amp;flashvars[chapters.layout]=vertical&amp;flashvars[chapters.thumbnailRotator]=false&amp;flashvars[streamSelector.plugin]=true&amp;flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&amp;flashvars[dualScreen.plugin]=true&amp;flashvars[hotspots.plugin]=1&amp;flashvars[Kaltura.addCrossoriginToIframe]=true&amp;&wid=1_hl7l2qu9"
                                videoTitle="What is ERM at PJM?"
                            />
                        </div>
                   </div>
                </div>
                <div className="row row-wrapper content m-t-40">
                    <div className="col-xs-12">
                        <h5 className="text--uppercase">PJM continued to focus on growing its risk management capabilities in&nbsp;2021</h5>
                    </div>                             
                </div>
                <div className="row row-wrapper donut-animation content">
                    <div className="col-xs-12 col-md-6">
                        <ul>
                            <li className="text">2021 marked the implementation of an enhanced Enterprise Risk Management strategy and practices across all PJM divisions.</li>

                            <li className="text">PJM testified before FERC in February to offer insight on credit principles and practices, including recent, key reforms by PJM as part of the comprehensive overhaul of credit risk mitigation policies and procedures. </li>

                            <li className="text">PJM and stakeholders also fully explored external clearing of the Financial Transmission Rights (FTR) Market.</li>
                        </ul>
                        <p className="text">Collectively, these steps represented progress toward fulfillment of comprehensive risk mitigation recommendations proposed by independent consultants to the PJM Board of Managers in 2019. PJM continues ongoing discussion of future market mitigation methodology enhancements with our stakeholders via forums such as the Risk Management Committee. </p>
                        <p className="text">PJM will continue its work to implement additional approaches to mitigate, prevent and respond to risk in collaboration, coordination and communication with PJM members.  </p>
                    </div>
                    <div className="col-xs-12 col-md-6 text--center">
                        <VisibilitySensor partialVisibility={true} offset={{top: 100}} onChange={onChangeVideo}>
                            <div style={{position: 'relative'}}>
                                <ReactPlayer 
                                    playing={playVideo}
                                    url={videoUrl} 
                                    width='100%'
                                    height='100%'
                                    className='react-player'
                                    muted
                                    playsinline
                                />
                            </div>
	    			    </VisibilitySensor>   
                    </div>
                </div>
               
                <div className="row row-wrapper content">
                    <div className="col-xs-12">
                        <h5 className="text--uppercase m-t-60">GridEx Supports Industry Coordination, Emergency Preparedness</h5>
                        <p className="text">PJM joined electricity industry organizations and government officials across North America for GridEx VI, a biennial grid security exercise hosted by the North American Electric Reliability Corporation (NERC). This exercise, held on Nov. 16–17, is designed to strengthen vital protocols in response to simulated cyberattacks and physical attacks on critical infrastructure in real time.</p>
                        <ul>
                            <li className="text">PJM’s GridEx participation involved more than 300 personnel during this biennial exercise. Teams included physical security, cybersecurity, information technology, gas-electric coordination, operations, communications and more. </li>
                            <li className="text">PJM applies critical lessons learned to further hone emergency response and preparedness, training, and tools in response to evolving threats to our bulk electric system.</li>
                            <li className="text">PJM has been a GridEx participant since the program’s inception in 2011.</li>
                        </ul>
                    </div>
                </div> 
                <div className="row row-wrapper content">
                    <div className="col-xs-12">
                        <h5 className="text--uppercase m-t-60">PJM Hosts Joint Cybersecurity Information Session</h5>
                        <p className="text">PJM and its members take cybersecurity threats to the bulk electric system very seriously. Industry coordination of information about threats to the bulk electric system is a crucial component to maintaining the reliable distribution of power to 65 million customers in 13 states and the District of Columbia.</p>
                        <p className="text">Last November, PJM reviewed the current threat landscape with peer organizations, including PJM members and stakeholders, grid operators, and the Electricity Information Sharing Analysis Center (E-ISAC). Information was shared by the Cybersecurity Risk Information Sharing Program, known as CRISP, which promotes and enables secure information sharing between private sector utilities and the U.S. Department of Energy.</p>
                        <p className="text">Through actionable and informed coordination with government partners, PJM and its members are better positioned to prepare for and respond to cyber and physical threats and to minimize disruptions.</p>
                    </div>
                </div>
                <div
                    className="circle--yellow page-1" 
                    ref={(element) => circles.current[4] = element}
                    data-speed="-.3"
                ></div>
                <div className="sec-pad">
                    <div className="row row-wrapper content">
                        <div className="col-xs-12 image-row">
                            <div className="profile profile--med">
                                <StaticImage loading="lazy" placeholder="blurred" quality="100" objectFit="cover" className="avatar" src="../images/RM_NERC_01.jpg" alt="" />
                                <img className="rings" src={ringsgy} alt="" /> 
                            </div>
                            <div className="profile profile--med">
                                <StaticImage loading="lazy" placeholder="blurred" quality="100" objectFit="cover" className="avatar" src="../images/RM_NERC_02_REV.jpg" alt="" />
                                <img className="rings" src={ringsbm} alt="" /> 
                            </div>
                            <div className="profile profile--med">
                                <StaticImage loading="lazy" placeholder="blurred" quality="100" objectFit="cover" className="avatar" src="../images/RM_NERC_03.jpg" alt="" />
                                <img className="rings" src={ringsmy} alt="" /> 
                            </div>
                            <div className="profile profile--med">
                                <StaticImage loading="lazy" placeholder="blurred" quality="100" objectFit="cover" className="avatar" src="../images/RM_NERC_04.jpg" alt="" />
                                <img className="rings" src={ringsbm} alt="" /> 
                            </div>
                        </div>
                    </div>
                </div>
                <div className="quote-wrap bg-blue sec-pad">
                    <div className="row row-wrapper content">
                        <div className="col-xs-12">
                            <div className="p-t-40 p-b-40">
                                <div className="row row-wrapper content max--1024">
                                    <div className="col-xs-12 text--center">
                                        <p className="text text--yellow text--large quote-text">“Cybersecurity is the ultimate team sport. Partnership and collaboration are essential. The importance of working across the industry, and with our state and federal government partners, to share threat information and best practices cannot be overstated.”</p>
                                        <p className="text text--uppercase text--yellow text--large quote-name">Tom O’Brien, Senior Vice President & Chief Information Officer</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer 
                nextLink="/innovation" 
                nextImage={nextImage}
                nextText="Next &gt;"
                nextTitle="Innovation"
                nextButton="Read More"   
                nextRings={nextRings}
                prevLink="/planning" 
                prevImage={prevImage}
                prevText="&lt; Previous"
                prevButton=""
                prevTitle="Planning" 
                prevRings={prevRings} 
            />
        </Layout>
    )
}

export default RiskManagementPage
